module.exports = __webpack_public_path__ + "img/head.2c4ee839.png";